{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Meer foto's toevoegen"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Goedkeuren"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Terug"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Terug naar Inloggen"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "In rekening brengen aan kamer"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Meer kopen"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Annuleren"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Sluiten"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Aankoop afronden"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Doorgaan"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Creditcard of betaalpas"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "KLAAR"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Downloaden"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Bestelling bewerken"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Invoeren"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Vergeten"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Ik begrijp het"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Volgende (pijl naar rechts)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Vorige (pijl naar links)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "In-/uitzoomen"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Uitloggen"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Inloggen"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Zoekgalerij"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Meer foto's"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nieuwe bestelling"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "Oké"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Prijsgids"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Afdrukken"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Verwerken"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Kopen"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Vernieuwen"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Verwijderen"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Afdrukken verwijderen"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Controleren en kopen"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Selecteren"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Geselecteerde afdrukformaten ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Link versturen"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Links versturen"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Delen"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Ingelogd blijven"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe-terminal"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Galerij bekijken"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Mijn galerij bekijken"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Ontvangstbewijs bekijken"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Je kunt gratis meer foto's toevoegen"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Toepassen"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Prijs voor alles is "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Alle afbeeldingen kopen voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " voor alles"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Winkelwagengegevens"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Totaal in winkelwagen"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Afrekenen"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Kortingscode"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Creditcard of betaalpas"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Digitale foto('s)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeelding"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeeldingen"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeelding"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeeldingen"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " en "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdrukken"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Meer afbeeldingen kopen met korting"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Deze "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " krijg je gratis."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "We hebben een link naar je galerij verstuurd naar "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Selecteer eerst de afbeelding(en) die je wilt kopen"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "op "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Krijg "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afbeelding"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afbeeldingen"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Alle afbeeldingen kopen voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Download "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "–"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " afbeeldingen voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "–"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " voor "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Prijsgids"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Zie de Prijsgids voor prijsdetails"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdrukken"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Kopen"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Gekocht"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Wordt gekocht"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Sorry, er was een probleem waardoor deze betaling niet kon worden uitgevoerd. Probeer het opnieuw en neem contact met ons op als het probleem zich blijft voordoen."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "De standaardprijs is "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " per stuk"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Bedankt voor je aankoop."
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Totaal"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Alle digitale foto's"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Alle digitale foto's en afdrukken"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Niet gekocht"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Foto’s bekijken"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Koop "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afbeelding"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afbeeldingen"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " met "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": "% korting"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": "% korting bij "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " of meer"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Door CaptureLife te gebruiken, stem je in met onze"
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Voer je wachtwoord in en bevestig het."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Bevestiging wachtwoord"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Contact opnemen"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-mail of telefoon"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "E-mailadres of telefoonnummer"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mailadres"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Voer een e-mailadres in."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Voer een wachtwoord in."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Voer een geldig e-mailadres of telefoonnummer in."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD en alle gerelateerde handelsmerken, personages, namen en kenmerken zijn © & ™ Warner Bros. Entertainment Inc. Publicatierechten © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Voer je e-mailadres of telefoonnummer in om je wachtwoord opnieuw in te stellen"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Wachtwoord vergeten?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Afdrukwinkel"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "QR-code genereren"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Sorry, deze link is verlopen. Voer je e-mailadres of telefoonnummer in om een nieuwe link te ontvangen."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Inloggen..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Laten we nog eens van die bijzondere momenten genieten!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Oeps, je bent iets vergeten."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Mijn persoonlijke gegevens"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Foto's toevoegen"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Toevoegen"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Terug"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Downloaden"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Home"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Uitloggen"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Nieuws"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Afdrukwinkel"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profiel"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Vernieuwen"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Delen"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Je wachtwoord moet minimaal "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " tekens bevatten."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Wachtwoord"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "De wachtwoorden komen niet overeen."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Maak een screenshot van je QR-code of klik hieronder op de knop Downloaden"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Wachtwoord opnieuw instellen"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Wachtwoord opnieuw instellen..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Alles selecteren"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Je kunt een foto downloaden of delen door deze ingedrukt te houden tot de opties voor het delen op je apparaat verschijnen."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Online winkel"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Gebruiksvoorwaarden"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Voer het e-mailadres en wachtwoord in dat je wilt gebruiken."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Wachtwoord bijwerken"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Je wachtwoord bijwerken"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Wachtwoord wordt bijgewerkt..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Welkom terug!"
    }
  ],
  "error_coupon_already_used": [
    {
      "type": 0,
      "value": "Cannot apply discount code. This discount has already been applied to your account."
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Kortingscode kan niet worden toegepast. Het totale aankoopbedrag ligt onder het vereiste minimumbedrag"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Kortingscode niet gevonden"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Voer een geldig e-mailadres in."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Voer je e-mailadres in."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Vul de onderstaande velden in."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Reservering niet gevonden."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Geen foto’s voor dit account. Scan een polsbandje dat bij de fotobalie is gebruikt"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Geen foto’s voor dit account. Vraag een fotograaf of medewerker om hulp"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Creditcard of betaalpas"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mailadres"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "E-mailadres"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Achternaam"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Wachtwoord"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Prijs (in "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Kamernummer"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Geheime code"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Alles selecteren"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Alle afbeeldingen ontgrendelen"
    }
  ],
  "hpx_macao_disclaimer": [
    {
      "type": 0,
      "value": "By using any of the photo shooting props at The Londoner Macao (“Harry Potter – The Exhibition”) you acknowledge and agree that the use of Harry Potter – The Exhibition involves the collection of photographic images of the users (“Photographs” or “Images” and “Users”, respectively)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳門倫敦人（「哈利波特－展覽」）的任何拍攝道具，即表示閣下知悉並同意使用「哈利波特－展覽」涉及收集使用者的攝影圖像（分別為“照片”或“圖像”及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳门伦敦人（「哈利波特－展览」）的任何拍摄道具，即表示阁下知悉并同意使用「哈利波特－展览」涉及收集使用者的摄影图像（分别为“照片”或“图像” 及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You further acknowledge and agree that HPX Macau Limited and its affiliated entities (“the Company”) have engaged a third-party service provider to provide photographic imaging and services solutions for Harry Potter - The Exhibition (“Service Provider”) with servers located in the United States of America (“USA”), in a jurisdiction with different laws and protections than the ones of the Macau Special Administrative Region (“MSAR”)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下亦知悉並同意HPX 澳門有限公司及其附屬實體（「本公司」）已聘請第三方服務提供者為《哈利波特- 展覽》提供攝影圖像和服務方案（「服務提供者」），其伺服器位於美利堅合眾國（「美國」），該司法管轄的法律和保護與澳門特別行政區（「澳門特別行政區」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下亦知悉并同意HPX 澳门有限公司及其附属实体（「本公司」）已聘请第三方服务提供者为《哈利波特- 展览》提供摄影圖像和服务方案（「服务提供者」），其伺服器位于美利坚合众国（「美国」），该司法管辖的法律和保护与澳门特别行政区（「澳门特别行政区」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You understand that the Images are collected so that Users may purchase their photographs in loco and are kept for the duration of the event, until January 5th, 2025, in servers in the USA, after which they are automatically deleted. The Company and the Service Provider take appropriate safety measures to help safeguard the Photographs and Images collected from any unauthorized access and disclosure and only authorized employees of both the Company or the Service Provider have access to them, exclusively for permitted business functions and by using a valid user name and password.  While the Company and the Service Provider use reasonable efforts to prevent loss, misuse, or alteration of the Photographs and Images, no method of storage or transmission over the Internet is completely secure, so the use of Harry Potter - The Exhibition is at Users’ own risk."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下明白收集圖像的目的是為了讓使用者可以即時於場地內購買照片，並在活動期間（直至 2025 年 1 月 5 日）保存在美國的伺服器中，之後它們將自動刪除。 「本公司」及「服務提供者」採取適當安全措施，以保護所收集的照片及圖像免遭任何未經授權的存取及披露，並且只有「本公司」或「服務提供者」的授權員工限於允許的業務功能並透過使用有效的使用者名稱及密碼才能存取這些照片及圖像。 儘管「本公司」及「服務提供者」合理努力防止照片及圖像遺失、被濫用或被篡改，網路上沒有任何儲存或傳輸方式是完全安全的，因此使用 \"哈利-波特--展覽 \"的風險由使用者自行承擔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下明白收集图像的目的是为了让使用者可以即时于场地内购买照片，并在活动期间（直至 2025 年 1 月 5 日）保存在美国的伺服器中，之后它们将自动删除。「本公司」及「服务提供者」采取适当安全措施，以保护所收集的照片及图像免遭任何未经授权的存取及披露，并且只有「本公司」或「服务提供者」的授权员工限于允许的业务功能并透过使用有效的使用者名称及密码才能存取这些照片及图像。尽管「本公司」及「服务提供者」合理努力防止照片及图像遗失、被滥用或被篡改，网路上没有任何储存或传输方式是完全安全的，因此使用\"哈利-波特--展览\"的风险由使用者自行承担。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You release, discharge, and agree to hold harmless and defend the Company, the Service Provider, their legal representatives or assignees, and all persons acting under their permission or authority, from any liability by virtue of any reason in connection with the making, collection, processing and storage of the Photographs and Images, including without limitation any claims for libel or violation of any right of image, publicity or privacy."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下免除、解除並同意「本公司」、「服務提供者」、其法定代表或代理人以及在其許可或授權下執行事務的所有人員免於承擔因任何原因而與照片及圖像的製作、收集、處理及儲存有關的任何責任，包括但不限於任何誹謗或侵犯任何肖像權、公開權或隱私權的索賠。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下免除、解除并同意「本公司」、「服务提供者」、其法定代表或代理人以及在其许可或授权下执行事务的所有人员免于承担因任何原因而与照片及图像的制作、收集、处理及储存有关的任何责任，包括但不限于任何诽谤或侵犯任何肖像权、公开权或隐私权的索赔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "The use of Harry Potter - The Exhibition is governed by the laws of the MSAR and any disputes, claims or differences arising out of or in connection with such use shall be submitted to the Courts of the MSAR."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展覽》的使用受澳門特別行政區法律管轄，任何因使用而產生或與之相關的爭議、索賠或分歧均應提交澳門特別行政區法院處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展览》的使用受澳门特别行政区法律管辖，任何因使用而产生或与之相关的争议、索赔或分歧均应提交澳门特别行政区法院处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "For requests related with the collection and storage of Photographs and Images please contact the Company through the email address privacy@sands.com.mo. The Company reserves the right to determine whether your request meets legal regulatory requirements and if it can be addressed."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有關收集及儲存照片及圖像的請求，請透過電子郵件方式privacy@sands.com.mo與「本公司」聯絡。 「本公司」保留權利以確定閣下的請求是否符合法律法規要求以及是否可以進行處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有关收集及储存照片及图像的请求，请透过电子邮件方式privacy@sands.com.mo与「本公司」联络。「本公司」保留权利以确定阁下的请求是否符合法律法规要求以及是否可以进行处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "This Consent has been translated into Chinese. If there is any inconsistency or ambiguity between the English version and the Chinese version, the English version shall prevail."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意書已翻譯成中文。 如果英文版本與中文版本之間存在任何不一致或歧義，以英文版本為準。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意书已翻译成中文。如果英文版本与中文版本之间存在任何不一致或歧义，以英文版本为准。"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Goedkeuring vereist"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Vraag een medewerker om hulp"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Aankoop goedkeuren"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Voer de prijs in voor deze aankoop."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Je wordt automatisch uitgelogd over "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconde"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconden"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Ben je er nog?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeelding"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale afbeeldingen"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdruk"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " afdrukken"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Controleren en kopen"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Tik op "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " om een foto uit je winkelwagen te verwijderen. Tik op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AANKOOP AFRONDEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om door te gaan."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Foto's toevoegen aan je galerij"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Selecteer de foto's die je wilt kopen"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Tik op foto's om ze aan je galerij toe te voegen. Tik op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MIJN GALERIJ BEKIJKEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om terug te keren naar je galerij."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Tik op foto's om ze aan je bestelling toe te voegen. Tik op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "CONTROLEREN EN KOPEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om door te gaan."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Foto's worden geladen..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_enter_access_code": [
    {
      "type": 0,
      "value": "Enter Access Code"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Selecteren en kopen"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Jouw afbeeldingsgalerij"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Selecteren en afdrukken"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Jouw afbeeldingsgalerij"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Tik op een afbeelding om deze te selecteren voor aankoop. Tik op "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om door te gaan."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Je galerij is leeg. Tik op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MEER FOTO'S"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in de rechterbovenhoek van het scherm om door beschikbare foto's te bladeren."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Tik op het afdrukicoontje op een foto om deze te selecteren. Tik op de knop Afdrukken om geselecteerde foto's te downloaden"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Tik op een afbeelding om deze te selecteren voor aankoop. Dubbeltik om een afdruk aan te vragen. Tik op "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om door te gaan."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Je hebt alle foto's ontgrendeld. Tik op "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " om ze uit je galerij te verwijderen."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Je hebt alle foto's ontgrendeld. Tik op een foto om een afdruk aan te vragen. Tik op "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " om ze uit je galerij te verwijderen."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Afdruk toevoegen"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digitaal gekocht"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Afdruk gekocht"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Afdruk geselecteerd"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Afdruk verwijderen"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Afdruk selecteren"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Jouw afbeeldingen"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Afbeeldingen selecteren"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Jouw selectie"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Jouw afbeeldingen bekijken"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Voer je kamernummer, achternaam en e-mailadres in om toegang te krijgen tot je galerij"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Welkom!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD en alle gerelateerde handelsmerken, personages, namen en kenmerken zijn © & ™ Warner Bros. Entertainment Inc. Publicatierechten © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Voer je e-mailadres in om door te gaan."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Scan je polsbandje om te beginnen"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "In rekening brengen aan kamer"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Het onderstaande bedrag wordt aan je kamer in rekening gebracht"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Aankoop afronden"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Je bestelling bestaat uit:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Alle verkopen zijn definitief en er is geen terugbetaling mogelijk."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Bestelgegevens"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Tik links op de foto's om ze te kopen."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Je winkelwagen is leeg. Tik op foto's om ze aan je bestelling toe te voegen."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Je winkelwagen is leeg. Tik op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MEER FOTO'S TOEVOEGEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " om meer foto's toe te voegen"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Je ontvangt je foto's per e-mail"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Dubbeltik op de foto om een afdruk aan te vragen."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Aankoop afronden"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Hoe wil je je aankoop doen?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Prijsgids"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Meer afbeeldingen kopen met korting"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "De standaardprijs is "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per afbeelding"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Je kunt gratis meer foto's toevoegen"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Afdrukformaten"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Selecteer afdrukformaat/-formaten en aantal"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Betaling wordt verwerkt..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Beschikbare kortingen:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Beschikbare pakketten:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per afbeelding"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Standaardprijs:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Totaal:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Tik op foto's om ze aan je bestelling toe te voegen"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Tik op foto's om ze te selecteren of deselecteren. Om meer foto's uit je selectie toe te voegen, tik je op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MEER FOTO'S"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Geen verbinding met terminal"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Verwerking terminal mislukt"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Terminal staat op stand-by..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Aankoop afgerond"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "We hebben een link naar je galerij verstuurd naar "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Wil je deze foto uit je bestelling verwijderen? Je moet die dan opnieuw zoeken door op "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MEER FOTO'S TOEVOEGEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " te tikken."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Kamer "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Kamers "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Er is een link per e-mail verzonden naar "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_search_images": [
    {
      "type": 0,
      "value": "Search Images"
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Beeldverhouding"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Geselecteerde afdrukken"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Moment"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Aantal"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Afdrukformaat"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Aankoop afronden"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Betaalgegevens invoeren"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Welkom, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Welkom, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}